import type { BaseIconProps } from "@/assets/icons/utils";
import type { FC } from "react";

export const IconAI: FC<BaseIconProps> = ({ size, className, ...props }) => {
    switch (size) {
        case "sm":
            return (
                <svg
                    className={className}
                    {...props}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clipPath="url(#clip0_182_1172)">
                        <path
                            d="M6.79654 10.0416C6.74446 9.83977 6.63924 9.65554 6.49182 9.50812C6.34439 9.3607 6.16016 9.25548 5.95829 9.2034L2.37954 8.28057C2.31848 8.26324 2.26474 8.22646 2.22648 8.17583C2.18821 8.12519 2.16751 8.06345 2.16751 7.99998C2.16751 7.93651 2.18821 7.87478 2.22648 7.82414C2.26474 7.7735 2.31848 7.73673 2.37954 7.7194L5.95829 6.79598C6.16009 6.74395 6.34428 6.63882 6.49169 6.49151C6.6391 6.34419 6.74437 6.16008 6.79654 5.95832L7.71937 2.37957C7.73653 2.31827 7.77326 2.26427 7.82398 2.2258C7.87469 2.18733 7.93659 2.1665 8.00025 2.1665C8.0639 2.1665 8.1258 2.18733 8.17652 2.2258C8.22723 2.26427 8.26397 2.31827 8.28112 2.37957L9.20337 5.95832C9.25545 6.16019 9.36067 6.34442 9.5081 6.49184C9.65552 6.63926 9.83975 6.74449 10.0416 6.79657L13.6204 7.71882C13.6819 7.73579 13.7362 7.77249 13.7749 7.82328C13.8135 7.87407 13.8345 7.93614 13.8345 7.99998C13.8345 8.06382 13.8135 8.1259 13.7749 8.17669C13.7362 8.22748 13.6819 8.26417 13.6204 8.28115L10.0416 9.2034C9.83975 9.25548 9.65552 9.3607 9.5081 9.50812C9.36067 9.65554 9.25545 9.83977 9.20337 10.0416L8.28054 13.6204C8.26338 13.6817 8.22665 13.7357 8.17593 13.7742C8.12522 13.8126 8.06332 13.8335 7.99966 13.8335C7.93601 13.8335 7.87411 13.8126 7.82339 13.7742C7.77268 13.7357 7.73594 13.6817 7.71879 13.6204L6.79654 10.0416Z"
                            stroke="currentColor"
                            strokeWidth="1.1"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M12.375 1.58337V5.08337"
                            stroke="currentColor"
                            strokeWidth="1.1"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M14.125 3.33337H10.625"
                            stroke="currentColor"
                            strokeWidth="1.1"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M3.625 10.9166V14.4166"
                            stroke="currentColor"
                            strokeWidth="1.1"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M5.375 12.6666H1.875"
                            stroke="currentColor"
                            strokeWidth="1.1"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_182_1172">
                            <rect width="14" height="14" fill="white" transform="translate(1 1)" />
                        </clipPath>
                    </defs>
                </svg>
            );
        case "base":
            return (
                <svg
                    className={className}
                    {...props}
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clipPath="url(#clip0_182_1175)">
                        <path
                            d="M8.62464 12.3334C8.56512 12.1026 8.44486 11.8921 8.27638 11.7236C8.1079 11.5551 7.89735 11.4349 7.66664 11.3754L3.57664 10.3207C3.50686 10.3009 3.44544 10.2589 3.40171 10.201C3.35798 10.1431 3.33432 10.0726 3.33432 10C3.33432 9.92749 3.35798 9.85693 3.40171 9.79906C3.44544 9.74119 3.50686 9.69916 3.57664 9.67936L7.66664 8.62402C7.89727 8.56456 8.10776 8.44441 8.27624 8.27605C8.44471 8.10769 8.56501 7.89728 8.62464 7.66669L9.6793 3.57669C9.69891 3.50664 9.74089 3.44492 9.79885 3.40095C9.85681 3.35699 9.92756 3.33319 10.0003 3.33319C10.073 3.33319 10.1438 3.35699 10.2018 3.40095C10.2597 3.44492 10.3017 3.50664 10.3213 3.57669L11.3753 7.66669C11.4348 7.8974 11.5551 8.10795 11.7236 8.27644C11.892 8.44492 12.1026 8.56517 12.3333 8.62469L16.4233 9.67869C16.4936 9.69809 16.5557 9.74003 16.5999 9.79807C16.6441 9.85612 16.668 9.92706 16.668 10C16.668 10.073 16.6441 10.1439 16.5999 10.202C16.5557 10.26 16.4936 10.302 16.4233 10.3214L12.3333 11.3754C12.1026 11.4349 11.892 11.5551 11.7236 11.7236C11.5551 11.8921 11.4348 12.1026 11.3753 12.3334L10.3206 16.4234C10.301 16.4934 10.259 16.5551 10.2011 16.5991C10.1431 16.6431 10.0724 16.6669 9.99964 16.6669C9.92689 16.6669 9.85614 16.6431 9.79818 16.5991C9.74023 16.5551 9.69824 16.4934 9.67864 16.4234L8.62464 12.3334Z"
                            stroke="currentColor"
                            strokeWidth="1.33333"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M15 2.66675V6.66675"
                            stroke="currentColor"
                            strokeWidth="1.33333"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M17 4.66675H13"
                            stroke="currentColor"
                            strokeWidth="1.33333"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M5 13.3333V17.3333"
                            stroke="currentColor"
                            strokeWidth="1.33333"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M7 15.3333H3"
                            stroke="currentColor"
                            strokeWidth="1.33333"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_182_1175">
                            <rect width="16" height="16" fill="white" transform="translate(2 2)" />
                        </clipPath>
                    </defs>
                </svg>
            );
        case "lg":
            return (
                <svg
                    className={className}
                    {...props}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clipPath="url(#clip0_182_1178)">
                        <path
                            d="M10.4527 14.625C10.3857 14.3655 10.2505 14.1286 10.0609 13.939C9.87138 13.7495 9.63451 13.6142 9.37495 13.5473L4.77371 12.3608C4.6952 12.3385 4.62611 12.2912 4.57691 12.2261C4.52772 12.161 4.5011 12.0816 4.5011 12C4.5011 11.9184 4.52772 11.839 4.57691 11.7739C4.62611 11.7088 4.6952 11.6615 4.77371 11.6393L9.37495 10.452C9.63442 10.3851 9.87122 10.2499 10.0608 10.0605C10.2503 9.87113 10.3856 9.63442 10.4527 9.375L11.6392 4.77375C11.6613 4.69494 11.7085 4.62551 11.7737 4.57605C11.8389 4.52659 11.9185 4.49982 12.0003 4.49982C12.0822 4.49982 12.1618 4.52659 12.227 4.57605C12.2922 4.62551 12.3394 4.69494 12.3615 4.77375L13.5472 9.375C13.6142 9.63456 13.7495 9.87143 13.939 10.061C14.1285 10.2505 14.3654 10.3858 14.625 10.4528L19.2262 11.6385C19.3053 11.6603 19.3751 11.7075 19.4248 11.7728C19.4746 11.8381 19.5015 11.9179 19.5015 12C19.5015 12.0821 19.4746 12.1619 19.4248 12.2272C19.3751 12.2925 19.3053 12.3397 19.2262 12.3615L14.625 13.5473C14.3654 13.6142 14.1285 13.7495 13.939 13.939C13.7495 14.1286 13.6142 14.3655 13.5472 14.625L12.3607 19.2263C12.3386 19.3051 12.2914 19.3745 12.2262 19.424C12.161 19.4734 12.0814 19.5002 11.9996 19.5002C11.9177 19.5002 11.8381 19.4734 11.7729 19.424C11.7077 19.3745 11.6605 19.3051 11.6385 19.2263L10.4527 14.625Z"
                            stroke="currentColor"
                            strokeWidth="1.33333"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M17.625 3.75006V8.25006"
                            stroke="currentColor"
                            strokeWidth="1.33333"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M19.875 6.00006H15.375"
                            stroke="currentColor"
                            strokeWidth="1.33333"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M6.375 15.7499V20.2499"
                            stroke="currentColor"
                            strokeWidth="1.33333"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M8.625 17.9999H4.125"
                            stroke="currentColor"
                            strokeWidth="1.33333"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_182_1178">
                            <rect width="18" height="18" fill="white" transform="translate(3 3)" />
                        </clipPath>
                    </defs>
                </svg>
            );
    }
};
